const ID_REGEXP = /^\d*_(.*)$/;

export function getMapDomIdFromInstance(mapInstanceId: string) {
  return (ID_REGEXP.exec(mapInstanceId) ?? undefined)?.[1];
}
